// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"07de5588","101":"65ed3afa","108":"6e10d570","213":"dc701bfb","239":"8842cf4e","332":"1fbb46b4","445":"70ea0707","449":"82aad728","455":"76ca8df9","478":"2e4cac24","527":"17af2661","653":"45cc293a","722":"52b1b27b","877":"bbdf0f39"}[chunkId] + ".chunk.js";
};